import { Link } from "react-router-dom";

const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|\*[^*]+\*)/g;

function Inline({ text }) {
  const parts = text.split(INLINE).filter(Boolean);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i}>{p.slice(2, -2)}</strong>;
    if (p.startsWith("*") && p.endsWith("*") && p.length > 2) return <em key={i}>{p.slice(1, -1)}</em>;
    const m = p.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (m) {
      const href = m[2];
      const cls = "text-primary font-semibold underline underline-offset-2 hover:text-primary/80";
      return href.startsWith("/") ? <Link key={i} to={href} className={cls}>{m[1]}</Link>
        : <a key={i} href={href} target="_blank" rel="noopener noreferrer" className={cls}>{m[1]}</a>;
    }
    return <span key={i}>{p}</span>;
  });
}

export function RichText({ text, className = "" }) {
  const lines = (text || "").split("\n");
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };
  lines.forEach((raw) => {
    const line = raw.trim();
    if (!line) { flush(); return; }
    if (line.startsWith("## ")) { flush(); blocks.push({ type: "h2", text: line.slice(3) }); return; }
    if (line.startsWith("### ")) { flush(); blocks.push({ type: "h3", text: line.slice(4) }); return; }
    if (line.startsWith("- ")) { if (!list || list.type !== "ul") { flush(); list = { type: "ul", items: [] }; } list.items.push(line.slice(2)); return; }
    const ol = line.match(/^(\d+)\.\s+(.*)$/);
    if (ol) { if (!list || list.type !== "ol") { flush(); list = { type: "ol", items: [] }; } list.items.push(ol[2]); return; }
    flush();
    blocks.push({ type: "p", text: line });
  });
  flush();

  return (
    <div className={`space-y-4 ${className}`}>
      {blocks.map((b, i) => {
        if (b.type === "h2") return <h2 key={i} id={`s-${i}`} className="font-display font-bold text-xl md:text-2xl mt-8 text-foreground">{<Inline text={b.text} />}</h2>;
        if (b.type === "h3") return <h3 key={i} className="font-display font-semibold text-lg mt-6">{<Inline text={b.text} />}</h3>;
        if (b.type === "ul") return <ul key={i} className="list-disc pl-6 space-y-1.5 text-foreground/85 leading-relaxed">{b.items.map((it, j) => <li key={j}><Inline text={it} /></li>)}</ul>;
        if (b.type === "ol") return <ol key={i} className="list-decimal pl-6 space-y-1.5 text-foreground/85 leading-relaxed">{b.items.map((it, j) => <li key={j}><Inline text={it} /></li>)}</ol>;
        return <p key={i} className="text-foreground/85 leading-relaxed"><Inline text={b.text} /></p>;
      })}
    </div>
  );
}
